module.exports = __webpack_public_path__ + "images/traditional-4-30d3147b735a7b9c781d38812adcc097.jpg";